<script>
import {
  getCustomerResource,
  exportCustomerResource,
} from '@/api/distributor-api'
import SettingAlarm from './components/SettingAlarm.vue'
import { filterEmptyProperties } from '@/utils'

export default {
  components: {
    SettingAlarm,
  },
  data() {
    return {
      formData: {
        appCode: '',
        serviceCode: '',
        billingType: 3,
        resourceStatus: [1],
        billingStatus: [1],
        pageSize: 10,
        pageIndex: 1,
      },
      appCodeObj: '',
      serviceCodeObj: '',
      tableData: [],
      total: 0,
      loading: false,
      billingStatus: [
        { label: '未到期', value: 1 },
        { label: '未欠费', value: 2 },
        { label: '已到期', value: 3 },
        { label: '已欠费', value: 4 },
      ],
      billingTypes: [
        { label: '按配置', value: 1 },
        { label: '按用量', value: 2 },
        { label: '包年包月', value: 3 },
        { label: '一次性', value: 4 },
        { label: '抢占式', value: 5 },
      ],
      resourceStatus: [
        { label: '正常', value: 1 },
        { label: '停服', value: 2 },
        { label: '删除', value: 3 },
      ],
      distributorTypes: [
        { label: '一级渠道商', value: 1 },
        { label: '二级渠道商', value: 2 },
        { label: '一级渠道客户', value: 3 },
        { label: '二级渠道客户', value: 4 },
      ],
      rules: {
        customerPin: {
          required: true,
          message: '请输入客户pin',
          trigger: 'blur',
        },
      },
    }
  },
  methods: {
    reset() {
      this.$refs['formRef'].resetFields()
      this.appCodeObj = ''
      this.serviceCodeObj = ''
    },
    search() {
      this.formData.pageIndex = 1
      this.getData()
    },
    getData() {
      this.$refs['formRef'].validate(async (valid) => {
        if (valid) {
          try {
            const { serviceCode, resourceCode } = this.serviceCodeObj
            this.formData.appCode = this.appCodeObj.code || ''
            this.formData.serviceCode = resourceCode || serviceCode || ''
            this.loading = true
            const options = {
              params: filterEmptyProperties(this.formData),
            }
            const { result } = await getCustomerResource(options)
            this.tableData = result.result || []
            this.total = result.pagination.numberRecords
          } catch (err) {
            console.log(err)
          } finally {
            this.loading = false
          }
        }
      })
    },
    handleExport() {
      this.$refs['formRef'].validate(async (valid) => {
        if (valid) {
          try {
            const options = {
              params: filterEmptyProperties(this.formData),
            }
            const { result } = await exportCustomerResource(options)
            this.$message.success(result.message)
            window.open(derivativeConfig.exportUrl)
          } catch (err) {
            console.log(err)
          }
        }
      })
    },
    handleSetting() {
      this.$refs['alarmRef'].open()
    },
    handleSizeChange(size) {
      this.formData.pageSize = size
      this.formData.pageIndex = 1
      this.getData()
    },
    handleCurrentChange(val) {
      this.formData.pageIndex = val
      this.getData()
    },
    productChange(value) {
      this.appCodeObj = value
    },
    changServiceCode(code) {
      console.log(code)
      this.serviceCodeObj = code
    },
    // 格式化显示
    formatText(enums, value) {
      if (value === '') {
        return '--'
      }
      const target = enums.find((item) => {
        return item.value === value
      })
      return target ? target.label : value
    },
  },
}
</script>

<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <div class="flex justify-between items-center pr-16px">
        <el-page-header title="渠道客户资源" />
        <el-button type="primary" @click="handleSetting"
          >资源到期提醒</el-button
        >
      </div>
    </div>
    <div class="jc-page-content">
      <div class="jc-page-card">
        <el-form
          :model="formData"
          label-width="100px"
          ref="formRef"
          collapse
          :rules="rules"
        >
          <el-form-item label="客户pin：" prop="customerPin">
            <el-input v-model="formData.customerPin" />
          </el-form-item>
          <el-form-item label="产品线：" prop="appCode">
            <ServicesLineSelect v-model="appCodeObj" @change="productChange" keyCode="code" />
          </el-form-item>
          <el-form-item label="产品：" prop="serviceCode">
            <JcbServiceCodeSelect
              v-model="serviceCodeObj"
              :app-id="appCodeObj.id"
              @change="changServiceCode"
            />
          </el-form-item>
          <el-form-item label="资源状态：" prop="resourceStatus">
            <el-select v-model="formData.resourceStatus" multiple clearable>
              <el-option
                v-for="(item, index) in resourceStatus"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="计费状态：" prop="billingStatus">
            <el-select v-model="formData.billingStatus" multiple clearable>
              <el-option
                v-for="(item, index) in billingStatus"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="计费类型：" prop="billingType">
            <el-select v-model="formData.billingType">
              <el-option
                v-for="(item, index) in billingTypes"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <template #action>
            <el-button type="primary" @click="search">查询</el-button>
            <el-button @click="reset">重置</el-button>
            <el-button @click="handleExport">导出</el-button>
          </template>
        </el-form>
      </div>
      <div class="jc-page-card">
        <el-table
          v-loading="loading"
          :data="tableData"
          stripe
          style="width: 100%"
        >
          <el-table-column prop="appCodeName" label="产品线">
            <template #default="scope">{{
              scope.row.appCodeName || '--'
            }}</template>
          </el-table-column>
          <el-table-column prop="serviceCodeName" label="产品名称">
            <template #default="scope">{{
              scope.row.serviceCodeName || '--'
            }}</template>
          </el-table-column>
          <el-table-column prop="customerPin" label="客户pin">
            <template #default="scope">{{
              scope.row.customerPin || '--'
            }}</template>
          </el-table-column>
          <el-table-column prop="loginName" label="客户账户名">
            <template #default="scope">{{
              scope.row.loginName || '--'
            }}</template>
          </el-table-column>
          <el-table-column prop="distributorType" label="客户类型">
            <template #default="scope">{{
              formatText(distributorTypes, scope.row.distributorType)
            }}</template>
          </el-table-column>
          <el-table-column prop="resourceId" label="资源ID">
            <template #default="scope">{{
              scope.row.resourceId || '--'
            }}</template>
          </el-table-column>
          <el-table-column prop="billingType" label="计费类型">
            <template #default="scope">
              {{ formatText(billingTypes, scope.row.billingType) }}
            </template>
          </el-table-column>
          <el-table-column prop="resourceStatus" label="资源状态">
            <template #default="scope">
              {{ formatText(resourceStatus, scope.row.resourceStatus) }}
            </template>
          </el-table-column>
          <el-table-column prop="billingStatus" label="计费状态">
            <template #default="scope">
              {{ formatText(billingStatus, scope.row.billingStatus) }}
            </template>
          </el-table-column>
          <el-table-column prop="expiringDays" label="过期天数">
            <template #default="scope">{{
              scope.row.expiringDays || '--'
            }}</template>
          </el-table-column>
          <el-table-column prop="stopTime" label="停服/预计停服时间">
            <template #default="scope">{{
              scope.row.stopTime || '--'
            }}</template>
          </el-table-column>
          <el-table-column prop="deleteTime" label="删除/预计删除时间">
            <template #default="scope">{{
              scope.row.deleteTime || '--'
            }}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间">
            <template #default="scope">{{
              scope.row.createTime || '--'
            }}</template>
          </el-table-column>
          <el-table-column prop="endTime" label="到期时间">
            <template #default="scope">{{
              scope.row.endTime || '--'
            }}</template>
          </el-table-column>
        </el-table>
        <div class="jc-list__action-bar mt-16px">
          <div class="jc-list__action-bar--right">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="formData.pageIndex"
              :page-sizes="[10, 20, 50]"
              :page-size="formData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <SettingAlarm ref="alarmRef" />
  </div>
</template>

<style scoped>
/deep/.el-select {
  width: 100%;
}
</style>
